import { Search } from "lucide-react";
import { SearchRoute } from "./routes/SearchRoute";

export const SEARCH_ROUTES = {
  search: {
    key: "search",
    path: "/search",
    title: "Search",
    icon: <Search size={17} />,
    element: <SearchRoute />
  }
};
